export default __webpack_public_path__ + "static/media/letter-tutorial-tip-04.b685bfc2.svg";